import { Button, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


function Error() {
    const navigate = useNavigate();
    const stackClass = 'justify-content-center col-md-5 mx-auto ';

    const login = () => {
        navigate('/login');
    }
    return (
        <Stack className={stackClass} gap={3}>
            <div className="alert alert-danger" role="alert">
                Anmeldung fehlgeschlagen!
            </div>
            <Button variant="primary" onClick={login}>Anmelden</Button>
        </Stack>



    )
}

export default Error;